import { Action } from '@ngrx/store';
import { SoffApiExceptionDto, SoffApiResponseDto } from '@soff/shared-ui';

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
export const LOAD_PAGE = '[Log Messages] Load page';
export const LOAD_PAGE_SUCCESS = '[Log Messages] Load page successful';
export const LOAD_PAGE_FAILURE = '[Log Messages] Load page failed';

export interface LogMessagePagePayload {
  rsqlFilter: string | null;
  filterValues: Record<string, string[]>;
  offset: number;
  pageSize: number;
  sortColumn: string | null;
  sortDirection: string | null;
}

export class LoadLogMessagesPage implements Action {
  readonly type = LOAD_PAGE;
  constructor(public payload: LogMessagePagePayload) {}
}

export class LoadLogMessagesPageSuccessful implements Action {
  readonly type = LOAD_PAGE_SUCCESS;
  constructor(
    public payload: LogMessagePagePayload & {
      response: SoffApiResponseDto;
    }
  ) {}
}

export class LoadLogMessagesPageFailed implements Action {
  readonly type = LOAD_PAGE_FAILURE;
  constructor(
    public payload: LogMessagePagePayload & {
      error: SoffApiExceptionDto;
    }
  ) {}
}

export type Actions = LoadLogMessagesPage | LoadLogMessagesPageSuccessful | LoadLogMessagesPageFailed;
